import { composeURL } from '@shared/utils/utils';
import { SERVIZI_ROUTE } from 'src/app/app.routes';

export const CPI_SLUG = 'cpi';
export const CPI_ROUTE = composeURL(SERVIZI_ROUTE, CPI_SLUG);
export const getCPIRoute = () => CPI_ROUTE;

export const ENTE_SLUG = 'ente';
export const ENTE_ROUTE = composeURL(SERVIZI_ROUTE, ENTE_SLUG);
export const getEnteRoute = () => ENTE_ROUTE;

export const REGIONE_SLUG = 'regione';
export const REGIONE_ROUTE = composeURL(SERVIZI_ROUTE, REGIONE_SLUG);
export const getRegioneRoute = () => REGIONE_ROUTE;

export const ALUNNO_SLUG = 'alunno';
export const ALUNNO_ROUTE = composeURL(SERVIZI_ROUTE, ALUNNO_SLUG);
export const getAlunnoRoute = () => ALUNNO_ROUTE;

export const DOCENTE_SLUG = 'docente';
export const DOCENTE_ROUTE = composeURL(SERVIZI_ROUTE, DOCENTE_SLUG);
export const getDocenteRoute = () => DOCENTE_ROUTE;

export const PRESIDENTE_SLUG = 'presidente';
export const PRESIDENTE_ROUTE = composeURL(SERVIZI_ROUTE, PRESIDENTE_SLUG);
export const getPresidenteRoute = () => PRESIDENTE_ROUTE;

export const TUTOR_SLUG = 'tutor';
export const TUTOR_ROUTE = composeURL(SERVIZI_ROUTE, TUTOR_SLUG);
export const getTutorRoute = () => TUTOR_ROUTE;
